import { createApp } from 'vue'
import { createRouter, createWebHistory } from "vue-router";
import Web from './Web.vue'
import { createGtm } from '@gtm-support/vue-gtm';
import "./assets/fonts.css"
import { RouterLink, RouterView } from 'vue-router';


const routes = [
    {
        path: '/',
        name: 'Home',
        component: () => import('./App.vue')
    },
    {
        path: '/politica-cookies',
        name: 'Cookies',
        component: () => import('./Cookies.vue')
    }
];

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior: function (to, _from, savedPosition) {
        window.scrollTo(0, 0);
     }
})

const app = createApp(Web)
app.component('RouterView', RouterView)
app.component('RouterLink', RouterLink)
app.use(router)

const gtmID = process.env.VUE_APP_GTM_ID

app.use(createGtm({
    id: gtmID,
    vueRouter: router
}))
app.mount('#app')
